module.exports = __webpack_public_path__ + "static/img/felix_logo.bad4fedf.svg";